import { render, staticRenderFns } from "./VideoGeneration.vue?vue&type=template&id=7014577c&scoped=true"
import script from "./VideoGeneration.vue?vue&type=script&lang=js"
export * from "./VideoGeneration.vue?vue&type=script&lang=js"
import style0 from "./VideoGeneration.vue?vue&type=style&index=0&id=7014577c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7014577c",
  null
  
)

export default component.exports